<template>
  <div class="header-lib-block">
    <div class="nav block">
      <SearchLib :class="{ 'hide-mobile': !isMaterials }" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SearchLib from '@/components/libs/SearchLib'

export default {
  name: 'HeaderLib',
  components: { SearchLib },
  computed: {
    isMaterials() {
      return this.$route.name.toLowerCase().includes('materials')
    },
  },
}
</script>

<style lang="scss">
.header-lib-block {
  position: relative;
  z-index: 2;

  .nav {
    border-radius: 5px;
    padding: 0;

    @include mobile {
      margin: -20px -20px 12px;
      box-shadow: none;
      background: transparent;
    }

    @include PC {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 28px;
      margin-bottom: 21px;
    }

    .items {
      display: flex;
      overflow: auto;
      white-space: nowrap;
      padding: 0 12px;

      &::after {
        content: '';
        display: block;
        padding: 6px;
      }

      @include PC {
        padding: 0;

        &::after {
          display: none;
        }
      }

      .item {
        margin: 0 8px;
        padding: 19px 0;
        border-top: 3px solid transparent;
        color: $dark;
        font-size: 14px;
        line-height: 178.5%;
        text-decoration: none;

        &[disabled] {
          opacity: 0.5;
          pointer-events: none;
        }

        &.router-link-active {
          border-top-color: $primary;
          font-weight: bold;
          color: $text;
        }

        @include PC {
          padding: 25px 0;
        }
      }
    }
  }
}
</style>
